module.exports = __webpack_public_path__ + "static/media/logoFooterEmiliaWhite.a2fbe918.png";